import React from 'react';

const OutputCenterTitle = ({ record }) => {
	return <span>OutputCenter {record ? `"${record.name}"` : ''}</span>;
};

export default OutputCenterTitle;
